import { render, staticRenderFns } from "./NavSvg.vue?vue&type=template&id=e28620cc&scoped=true&"
import script from "./NavSvg.vue?vue&type=script&lang=js&"
export * from "./NavSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28620cc",
  null
  
)

export default component.exports